/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminEmailLogRouteImport } from './routes/admin/email-log'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminTrackerRouteImport } from './routes/admin/tracker'
import { Route as AdminViewAsRouteImport } from './routes/admin/view-as'
import { Route as KbIndexRouteImport } from './routes/kb/index'
import { Route as KbSlugRouteImport } from './routes/kb/$slug'
import { Route as TicketsIndexRouteImport } from './routes/tickets/index'
import { Route as TicketsIdRouteImport } from './routes/tickets/$id'
import { Route as TicketsNewRouteImport } from './routes/tickets/new'
import { Route as TrackerIndexRouteImport } from './routes/tracker/index'
import { Route as TrackerIdRouteImport } from './routes/tracker/$id'
import { Route as TrackerPresentRouteImport } from './routes/tracker/present'
import { Route as AdminKbIndexRouteImport } from './routes/admin/kb/index'
import { Route as AdminKbIdRouteImport } from './routes/admin/kb/$id'
import { Route as AdminKbNewRouteImport } from './routes/admin/kb/new'
import { Route as AdminTicketsIdRouteImport } from './routes/admin/tickets/$id'
import { Route as AdminTicketsIdInvestigationRouteImport } from './routes/admin/tickets/$id_.investigation'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailLogRoute = AdminEmailLogRouteImport.update({
  id: '/admin/email-log',
  path: '/admin/email-log',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTrackerRoute = AdminTrackerRouteImport.update({
  id: '/admin/tracker',
  path: '/admin/tracker',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminViewAsRoute = AdminViewAsRouteImport.update({
  id: '/admin/view-as',
  path: '/admin/view-as',
  getParentRoute: () => rootRouteImport,
} as any)
const KbIndexRoute = KbIndexRouteImport.update({
  id: '/kb/',
  path: '/kb/',
  getParentRoute: () => rootRouteImport,
} as any)
const KbSlugRoute = KbSlugRouteImport.update({
  id: '/kb/$slug',
  path: '/kb/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIdRoute = TicketsIdRouteImport.update({
  id: '/tickets/$id',
  path: '/tickets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsNewRoute = TicketsNewRouteImport.update({
  id: '/tickets/new',
  path: '/tickets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackerIndexRoute = TrackerIndexRouteImport.update({
  id: '/tracker/',
  path: '/tracker/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackerIdRoute = TrackerIdRouteImport.update({
  id: '/tracker/$id',
  path: '/tracker/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackerPresentRoute = TrackerPresentRouteImport.update({
  id: '/tracker/present',
  path: '/tracker/present',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKbIndexRoute = AdminKbIndexRouteImport.update({
  id: '/admin/kb/',
  path: '/admin/kb/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKbIdRoute = AdminKbIdRouteImport.update({
  id: '/admin/kb/$id',
  path: '/admin/kb/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKbNewRoute = AdminKbNewRouteImport.update({
  id: '/admin/kb/new',
  path: '/admin/kb/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTicketsIdRoute = AdminTicketsIdRouteImport.update({
  id: '/admin/tickets/$id',
  path: '/admin/tickets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTicketsIdInvestigationRoute =
  AdminTicketsIdInvestigationRouteImport.update({
    id: '/admin/tickets/$id_/investigation',
    path: '/admin/tickets/$id/investigation',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/admin/email-log': typeof AdminEmailLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tracker': typeof AdminTrackerRoute
  '/admin/view-as': typeof AdminViewAsRoute
  '/kb/$slug': typeof KbSlugRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/tracker/$id': typeof TrackerIdRoute
  '/tracker/present': typeof TrackerPresentRoute
  '/admin/': typeof AdminIndexRoute
  '/kb/': typeof KbIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/tracker/': typeof TrackerIndexRoute
  '/admin/kb/$id': typeof AdminKbIdRoute
  '/admin/kb/new': typeof AdminKbNewRoute
  '/admin/tickets/$id': typeof AdminTicketsIdRoute
  '/admin/kb/': typeof AdminKbIndexRoute
  '/admin/tickets/$id/investigation': typeof AdminTicketsIdInvestigationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/admin/email-log': typeof AdminEmailLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tracker': typeof AdminTrackerRoute
  '/admin/view-as': typeof AdminViewAsRoute
  '/kb/$slug': typeof KbSlugRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/tracker/$id': typeof TrackerIdRoute
  '/tracker/present': typeof TrackerPresentRoute
  '/admin': typeof AdminIndexRoute
  '/kb': typeof KbIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/tracker': typeof TrackerIndexRoute
  '/admin/kb/$id': typeof AdminKbIdRoute
  '/admin/kb/new': typeof AdminKbNewRoute
  '/admin/tickets/$id': typeof AdminTicketsIdRoute
  '/admin/kb': typeof AdminKbIndexRoute
  '/admin/tickets/$id/investigation': typeof AdminTicketsIdInvestigationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/admin/email-log': typeof AdminEmailLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tracker': typeof AdminTrackerRoute
  '/admin/view-as': typeof AdminViewAsRoute
  '/kb/$slug': typeof KbSlugRoute
  '/tickets/$id': typeof TicketsIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/tracker/$id': typeof TrackerIdRoute
  '/tracker/present': typeof TrackerPresentRoute
  '/admin/': typeof AdminIndexRoute
  '/kb/': typeof KbIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/tracker/': typeof TrackerIndexRoute
  '/admin/kb/$id': typeof AdminKbIdRoute
  '/admin/kb/new': typeof AdminKbNewRoute
  '/admin/tickets/$id': typeof AdminTicketsIdRoute
  '/admin/kb/': typeof AdminKbIndexRoute
  '/admin/tickets/$id_/investigation': typeof AdminTicketsIdInvestigationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/admin/email-log'
    | '/admin/settings'
    | '/admin/tracker'
    | '/admin/view-as'
    | '/kb/$slug'
    | '/tickets/$id'
    | '/tickets/new'
    | '/tracker/$id'
    | '/tracker/present'
    | '/admin/'
    | '/kb/'
    | '/tickets/'
    | '/tracker/'
    | '/admin/kb/$id'
    | '/admin/kb/new'
    | '/admin/tickets/$id'
    | '/admin/kb/'
    | '/admin/tickets/$id/investigation'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/admin/email-log'
    | '/admin/settings'
    | '/admin/tracker'
    | '/admin/view-as'
    | '/kb/$slug'
    | '/tickets/$id'
    | '/tickets/new'
    | '/tracker/$id'
    | '/tracker/present'
    | '/admin'
    | '/kb'
    | '/tickets'
    | '/tracker'
    | '/admin/kb/$id'
    | '/admin/kb/new'
    | '/admin/tickets/$id'
    | '/admin/kb'
    | '/admin/tickets/$id/investigation'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/admin/email-log'
    | '/admin/settings'
    | '/admin/tracker'
    | '/admin/view-as'
    | '/kb/$slug'
    | '/tickets/$id'
    | '/tickets/new'
    | '/tracker/$id'
    | '/tracker/present'
    | '/admin/'
    | '/kb/'
    | '/tickets/'
    | '/tracker/'
    | '/admin/kb/$id'
    | '/admin/kb/new'
    | '/admin/tickets/$id'
    | '/admin/kb/'
    | '/admin/tickets/$id_/investigation'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  AdminEmailLogRoute: typeof AdminEmailLogRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminTrackerRoute: typeof AdminTrackerRoute
  AdminViewAsRoute: typeof AdminViewAsRoute
  KbSlugRoute: typeof KbSlugRoute
  TicketsIdRoute: typeof TicketsIdRoute
  TicketsNewRoute: typeof TicketsNewRoute
  TrackerIdRoute: typeof TrackerIdRoute
  TrackerPresentRoute: typeof TrackerPresentRoute
  AdminIndexRoute: typeof AdminIndexRoute
  KbIndexRoute: typeof KbIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  TrackerIndexRoute: typeof TrackerIndexRoute
  AdminKbIdRoute: typeof AdminKbIdRoute
  AdminKbNewRoute: typeof AdminKbNewRoute
  AdminTicketsIdRoute: typeof AdminTicketsIdRoute
  AdminKbIndexRoute: typeof AdminKbIndexRoute
  AdminTicketsIdInvestigationRoute: typeof AdminTicketsIdInvestigationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email-log': {
      id: '/admin/email-log'
      path: '/admin/email-log'
      fullPath: '/admin/email-log'
      preLoaderRoute: typeof AdminEmailLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tracker': {
      id: '/admin/tracker'
      path: '/admin/tracker'
      fullPath: '/admin/tracker'
      preLoaderRoute: typeof AdminTrackerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/view-as': {
      id: '/admin/view-as'
      path: '/admin/view-as'
      fullPath: '/admin/view-as'
      preLoaderRoute: typeof AdminViewAsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/': {
      id: '/kb/'
      path: '/kb'
      fullPath: '/kb/'
      preLoaderRoute: typeof KbIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/$slug': {
      id: '/kb/$slug'
      path: '/kb/$slug'
      fullPath: '/kb/$slug'
      preLoaderRoute: typeof KbSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$id': {
      id: '/tickets/$id'
      path: '/tickets/$id'
      fullPath: '/tickets/$id'
      preLoaderRoute: typeof TicketsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/new': {
      id: '/tickets/new'
      path: '/tickets/new'
      fullPath: '/tickets/new'
      preLoaderRoute: typeof TicketsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracker/': {
      id: '/tracker/'
      path: '/tracker'
      fullPath: '/tracker/'
      preLoaderRoute: typeof TrackerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracker/$id': {
      id: '/tracker/$id'
      path: '/tracker/$id'
      fullPath: '/tracker/$id'
      preLoaderRoute: typeof TrackerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracker/present': {
      id: '/tracker/present'
      path: '/tracker/present'
      fullPath: '/tracker/present'
      preLoaderRoute: typeof TrackerPresentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kb/': {
      id: '/admin/kb/'
      path: '/admin/kb'
      fullPath: '/admin/kb/'
      preLoaderRoute: typeof AdminKbIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kb/$id': {
      id: '/admin/kb/$id'
      path: '/admin/kb/$id'
      fullPath: '/admin/kb/$id'
      preLoaderRoute: typeof AdminKbIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kb/new': {
      id: '/admin/kb/new'
      path: '/admin/kb/new'
      fullPath: '/admin/kb/new'
      preLoaderRoute: typeof AdminKbNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tickets/$id': {
      id: '/admin/tickets/$id'
      path: '/admin/tickets/$id'
      fullPath: '/admin/tickets/$id'
      preLoaderRoute: typeof AdminTicketsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tickets/$id_/investigation': {
      id: '/admin/tickets/$id_/investigation'
      path: '/admin/tickets/$id/investigation'
      fullPath: '/admin/tickets/$id/investigation'
      preLoaderRoute: typeof AdminTicketsIdInvestigationRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  AdminEmailLogRoute: AdminEmailLogRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminTrackerRoute: AdminTrackerRoute,
  AdminViewAsRoute: AdminViewAsRoute,
  KbSlugRoute: KbSlugRoute,
  TicketsIdRoute: TicketsIdRoute,
  TicketsNewRoute: TicketsNewRoute,
  TrackerIdRoute: TrackerIdRoute,
  TrackerPresentRoute: TrackerPresentRoute,
  AdminIndexRoute: AdminIndexRoute,
  KbIndexRoute: KbIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  TrackerIndexRoute: TrackerIndexRoute,
  AdminKbIdRoute: AdminKbIdRoute,
  AdminKbNewRoute: AdminKbNewRoute,
  AdminTicketsIdRoute: AdminTicketsIdRoute,
  AdminKbIndexRoute: AdminKbIndexRoute,
  AdminTicketsIdInvestigationRoute: AdminTicketsIdInvestigationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
